const getSelectedElement = (rootState) => rootState.ws.view.selectedElement;

export default getSelectedElement;
